import Vue from "vue";

export default {
  name: "CameraCompWithViewPics",
  components: {
    CameraComp: require('@/components/camera/camera.vue').default,
    PaginationComp1: require('@/components/paginationComponent/paginationComponent.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
  },
  props: {
    displayCamera: {
      type: Boolean,
      default: false
      },
    uploadPic: {
      type: Function,
      default: null
    },
    getPics: {
      type: Function,
      default: null
    },
    downloadPic: {
      type: Function,
      default: null
    },
    viewPic: {
      type: Function,
      default: null
    },
    close: {
      type: Function,
      default: null,
    },
    closeAfterSave: {
      type: Boolean,
      default: false
    },
    isOffline: {
      type: Boolean,
      default: false
    },
    isFieldWorker: {
      type: Boolean,
      default: true
    },
    disableCapturePhotoTab: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      activeTab: null,
      showPicDialog: false,
      picList: [],
      img: null,
      totalPages: 1,
      pageSize: 5,
      currentPage: 1,
      paginationEnabled: false,

      showCamera: true,
      photoList: [],
      photoToDelete: null,
      deleteConfirmation: false,

      photosLoading: false,
    };
  },
  watch:{
    displayCamera: function (val) {
      if (!val)
        this.showPicDialog = false;
    }
  },
  created() {
    if (!this.isFieldWorker || this.disableCapturePhotoTab)
      this.activeTab = 'tab-view-pictured';
    else
      this.activeTab = 'tab-camera';
  },
  methods: {
    onPagination(e) {
      this.currentPage = e;
      this.getPhotosList();
    },
    tabChanged(tab) {
      if (tab == 'tab-view-pictured') {
        this.getPhotosList();
        this.showCamera = false;
      }
      else
        this.showCamera = true;
        
    },
    async photoTaken(obj) {
      obj.close = this.closeAfterSave;
      await this.uploadPic(obj);
    },
    closeCamera() {
      this.close();
    },

    async getPhotosList() {
      this.photosLoading = true;
      this.photoList = await this.getPics();
      this.photosLoading = false;
    },

    deletePicConfirmation(img) {
      this.photoToDelete = img;
      this.deleteConfirmation = true;
    },
    deleteConfirmationCancel() {
      this.photoToDelete = null;
      this.deleteConfirmation = false;
    },
    deletePicture() {      
      if (this.photoToDelete == null)
        return;
      else
        var img = this.photoToDelete;


      var formData = new FormData();
      let url;
    }, 

    downloadPicture(item) {
      this.downloadPic(item.id);
    },
    async viewPicture(item) {
      this.img = 'data:image/jpeg;base64,' + await this.viewPic(item.id);
      this.showPicDialog = true;
    }
  }
};
